<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="container-fluid" [ngClass]="usuario.retorno.aparencia">
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li>
      <span id="lblSubMenu">Edição de abastecimento da Frota</span>
    </li>
  </ul>
  <div class="panel panel-info">
    <!--    <div class="panel-heading">-->
    <!--      <h3 class="panel-title">Dados do abastecimento: <b>{{abastecimento.codAbastecimento}}</b></h3>-->
    <!--    </div>-->
    <div class="panel-body">
      <div class="row">

        <div class="col-md-2 form-group">
          <label class='center-block'>
            Cód. do Abastecimento
          </label>
          <input type="text" class="form-control" name="codigoFrota" value=""
            [(ngModel)]="abastecimento.codAbastecimento" disabled>
        </div>

        <div class="col-md-2 form-group">
          <label class='center-block'>
            Placa do veículo
          </label>
          <input type="text" class="form-control" [(ngModel)]="abastecimento.dscPlaca" disabled>
        </div>

        <div class="col-md-5 form-group">
          <label class='center-block'>
            Nome do posto
          </label>
          <input type="text" class="form-control" [(ngModel)]="abastecimento.nomFantasiaPosto" disabled>
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Código do posto
          </label>
          <input type="text" class="form-control" [(ngModel)]="abastecimento.codPosto" disabled>
        </div>
      </div>

      <div class="row">

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Data/Hora do Abastecimento
          </label>
          <input type="text" class="form-control" [ngModel]="abastecimento.datAbastecimento " disabled>
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Data/Hora do Debito
          </label>
          <input type="text" class="form-control" [ngModel]="abastecimento.datDebito " disabled>
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Data/Hora do Crédito
          </label>
          <input type="text" class="form-control" [ngModel]="abastecimento.datCredito  " disabled>
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Tipo do Produto
          </label>
          <input type="text" class="form-control" [(ngModel)]="abastecimento.dscTipoProduto" disabled>
        </div>
      </div>


      <div class="row">
        <div class="col-md-3 form-group">
          <label class="control-label">
            Combustível Abastecido
          </label>
          <div class="input-group">
            <select class="form-control" (change)="setCombustivel($event)">

              <option *ngFor="let comb of listaCombustiveis"
                [selected]="comb.descricaoCombustivel.trim().toUpperCase() === abastecimento.indCombustivel.trim().toUpperCase()"
                [value]="comb.descricaoCombustivel">{{comb.combustivel | titlecase}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label class='center-block'>
            Km do veiculo
          </label>
          <input type="text" class="form-control" [(ngModel)]="abastecimento.numKm" disabled>
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Volume abastecido (l)
          </label>
          <input type="number" min="0.01" step="0.01" class="form-control" [(ngModel)]="abastecimento.qtdVolume"
            (ngModelChange)="abastecimento.vlrTotal = abastecimento.qtdVolume * abastecimento.vlrUnitario"
            (focusout)="abastecimento.qtdVolume =  abastecimento.qtdVolume < 0.01 ? abastecimento.qtdVolume = 0.01 : abastecimento.qtdVolume"
            (focusout)="abastecimento.vlrTotal =  abastecimento.qtdVolume < 0.01 ? abastecimento.vlrUnitario * 0.01 :abastecimento.vlrUnitario * abastecimento.qtdVolume">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Vlr Untitário Desconto
          </label>
          <input type="text" class="form-control" [ngModel]="abastecimento.vlrUnitario | currency: 'R$'" disabled>
        </div>




      </div>

      <div class="row">



        <div class=" col-md-4 offset-md-8 form-group">
          <label class='center-block'>
            Valor Total
          </label>
          <input type="text" class="form-control" [ngModel]="abastecimento.vlrTotal | currency:'BRL':true"
            (ngModelChange)="onChangVlrTotal($event)" [ngModelOptions]="{ updateOn: 'blur' }">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group">
          <label class='center-block'>
            Comentário sobre a alteração
            <small>Campo Obrigatório!</small>
          </label>
          <textarea rows="5" [(ngModel)]="observacao" class="form-control">

        </textarea>
          <small *ngIf="observacao.length > 500">Tamanho máx. de 500 caracteres, por favor diminua o texto.</small>
        </div>
      </div>

      <div class="row">
        <div class="offset-md-8 col-md-4 botoes pull-right ">

          <button type="submit" (click)="cancelar()" class="btn btn-secondary btn-submit btn-filtrar">
            <i class="fa fa-undo"></i>Cancelar
          </button>
          <button type="submit" [disabled]="!exitemMudancas()" (click)="salvar()"
            class="btn btn-primary btn-submit btn-filtrar">
            <i class="fa fa-check"></i>Salvar Alterações
          </button>
        </div>
      </div>

    </div>
  </div>


</div>